export default "__VITE_ASSET__69c9c704__"